import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

const StyledLabel = styled(Typography)(({ theme }) => ({
  fontStyle     : 'normal',
  fontWeight    : 600,
  fontSize      : '16px',
  lineHeight    : '20px',
  letterSpacing : '0.02em',
  color         : theme.palette.primary.blue1,
  cursor        : 'pointer'
}));

const StyledLabelBox = styled(Box)(() => ({
  display        : 'flex',
  height         : '56px',
  alignItems     : 'center',
  justifyContent : 'center',
  textDecoration : 'none',
}));

export const LinkButton = ({ children, onClick , ...rest }) => (
  <StyledLabelBox
    {...rest}>
    <StyledLabel
      onClick={onClick}>
      {children}
    </StyledLabel>
  </StyledLabelBox>
);
